import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';

interface LanguageState {
  /** Language used for UI (i18n) */
  appLang: string;

  setAppLang: (lang: string) => void;
  resetLanguages: () => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      appLang: 'en',

      setAppLang: (lang) => set({ appLang: lang }),

      resetLanguages: () =>
        set({
          appLang: 'en',
        }),
    }),
    {
      name: 'language-store',
      storage: createJSONStorage(() => AsyncStorage),
      version: 2,
      migrate: (persistedState: unknown) => {
        if (
          persistedState &&
          typeof persistedState === 'object' &&
          'appLang' in persistedState
        ) {
          const s = persistedState as { appLang?: string };
          return { appLang: s.appLang ?? 'en' };
        }
        return { appLang: 'en' };
      },
    }
  )
);
